import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { shopifyService } from '../services/shopifyService';

export const ShopifyRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        // Salva a URL original do Shopify
        const originalUrl = window.location.href;
        
        // Verifica se o usuário está logado e tem companyId
        if (!currentUser?.companyId) {
          // Salva a URL do Shopify para redirecionamento após o login
          localStorage.setItem('shopifyRedirectUrl', originalUrl);
          navigate('/login');
          return;
        }

        const params = new URLSearchParams(window.location.search);
        const shop = params.get('shop');

        if (!shop) {
          throw new Error('Loja Shopify não especificada');
        }

        // Extrai o nome da loja do domínio (ex: lognowteste.myshopify.com -> lognowteste)
        const shopName = shop.replace('.myshopify.com', '');
        
        // Inicia o fluxo de autenticação com o companyId do usuário
        const authUrl = await shopifyService.generateAuthUrl(currentUser.companyId, shopName);
        window.location.href = authUrl;
      } catch (error) {
        console.error('Erro no redirecionamento do Shopify:', error);
        navigate('/dashboard/integrations/settings');
      }
    };

    handleRedirect();
  }, [navigate, currentUser]);

  return (
    <div className="p-8 text-center">
      <h1 className="text-2xl font-bold mb-4">Redirecionando para o Shopify...</h1>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
    </div>
  );
};
